import { BAlert, BImgLazy,BModal, BOverlay, BPopover } from 'bootstrap-vue'
import Vue from 'vue'

import TooltipCommon from '~/components/common/TooltipCommon'

Vue.component('BPopover', BPopover)
Vue.component('BModal', BModal)
Vue.component('BOverlay', BOverlay)
Vue.component('BAlert', BAlert)
Vue.component('BImgLazy', BImgLazy)

Vue.component('TooltipCommon', TooltipCommon)
